<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import SlideshowModal, {
  type Step,
} from '@/components/Base/Modal/SlideshowModal/SlideshowModal.vue'
import Welcome1 from '@/assets/uca/welcome1.png'
import Welcome2 from '@/assets/uca/welcome2.png'
import Welcome3 from '@/assets/uca/welcome3.png'
import Welcome4 from '@/assets/uca/welcome4.png'
import Welcome5 from '@/assets/uca/welcome5.png'
import Welcome6 from '@/assets/uca/welcome6.png'

const emit = defineEmits<{
  (e: 'close', dontShowAgain: boolean): void
}>()

const i18n = useI18n()

const steps = computed<Step[]>(() => [
  {
    image: Welcome1,
    title: i18n.t('uca.modal.tutorial.welcome1.title'),
    text: i18n.t('uca.modal.tutorial.welcome1.text'),
    button: {
      text: i18n.t('uca.modal.tutorial.welcome.next'),
      onClick: ({ next }) => next(),
    },
  },
  {
    image: Welcome2,
    title: i18n.t('uca.modal.tutorial.welcome2.title'),
    text: i18n.t('uca.modal.tutorial.welcome2.text'),
    button: {
      text: i18n.t('uca.modal.tutorial.welcome.next'),
      onClick: ({ next }) => next(),
    },
  },
  {
    image: Welcome3,
    title: i18n.t('uca.modal.tutorial.welcome3.title'),
    text: i18n.t('uca.modal.tutorial.welcome3.text'),
    button: {
      text: i18n.t('uca.modal.tutorial.welcome.next'),
      onClick: ({ next }) => next(),
    },
  },
  {
    image: Welcome4,
    title: i18n.t('uca.modal.tutorial.welcome4.title'),
    text: i18n.t('uca.modal.tutorial.welcome4.text'),
    button: {
      text: i18n.t('uca.modal.tutorial.welcome.next'),
      onClick: ({ next }) => next(),
    },
  },
  {
    image: Welcome5,
    title: i18n.t('uca.modal.tutorial.welcome5.title'),
    text: i18n.t('uca.modal.tutorial.welcome5.text'),
    button: {
      text: i18n.t('uca.modal.tutorial.welcome.next'),
      onClick: ({ next }) => next(),
    },
  },
  {
    image: Welcome6,
    title: i18n.t('uca.modal.tutorial.welcome6.title'),
    text: i18n.t('uca.modal.tutorial.welcome6.text'),
    button: {
      text: i18n.t('uca.modal.tutorial.welcome.finished'),
      onClick: ({ close }) => close(),
    },
  },
])
</script>

<template>
  <SlideshowModal
    :steps="steps"
    :width="'600px'"
    text-alignment="left"
    show-close-button
    data-test="uca-welcome-modal"
    showCheckbox
    :checkboxLabel="$t('uca.modal.tutorial.welcome.dontShowAgain')"
    @close="emit('close', $event)"
  />
</template>
